<template>
  <div>
    <v-tabs
      color="secondary"
      v-model="tab"
      :height="40"
      grow
      :mobile-break-point="300"
      class="ma-3"
      icons-and-text
    >
      <v-tabs-slider color="#BBCF20"></v-tabs-slider>
      <v-tab
        v-if="
          this.institution?.showEngClinic ||
          user.mainType == 0 ||
          user.mainType == 1
        "
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
      >
        {{ $t('Engenharia clinica') }}
        <img
          src="../../../../assets/figmaIcons/green/reports.svg"
          alt="Equip"
          style="object-fit: contain"
          class="ma-1 mr-2"
        />
      </v-tab>

      <v-tab
        v-if="
          this.institution?.showEngInfra ||
          user.mainType == 0 ||
          user.mainType == 1
        "
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
      >
        {{ $t('Engenharia de infraestrutura') }}
        <img
          src="../../../../assets/figmaIcons/green/reports.svg"
          alt="Equip"
          style="object-fit: contain"
          class="ma-1 mr-2"
        />
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-if="this.institution?.showEngClinic || user.mainType < 2">
        <PopsEngClinic ref="clinic" />
      </v-tab-item>
      <v-tab-item v-if="this.institution?.showEngInfra || user.mainType < 2">
        <PopsEngInfra ref="infra" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import PopsEngClinic from './PopsEngClinic.vue'
import PopsEngInfra from './PopsEngInfra.vue'

export default {
  name: 'PopsTabs',

  components: {
    PopsEngClinic,
    PopsEngInfra,
  },

  data() {
    return {
      tab: 0,
      visible: false,
      isLoading: false,
      institution: {},
      user: {},
    }
  },
  watch: {
    tab(newVal) {
      if (newVal === 0 && this.$refs.clinic) {
        this.$refs.clinic.loadData?.()
      } else if (newVal === 1 && this.$refs.infra) {
        this.$refs.infra.loadData?.()
      }
    },
  },
  created() {
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institution = institution

    const user = JSON.parse(localStorage.getItem('user'))
    this.user = user
  },
}
</script>
